// components/StyledInputLabel.tsx
import { InputLabel, styled } from "@mui/material";

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.text.primary || "#333333", // Use theme color or fallback to dark gray
  "&.Mui-focused": {
    color: theme.palette.primary.main, // Use theme's primary color when focused
  },
  "&.MuiInputLabel-shrink": {
    color: theme.palette.text.primary || "#333333", // Ensure color stays when shrunk
  },
}));
